export default __webpack_public_path__ + "static/media/first.d30ac282.gif";